import { useSyncExternalStore } from "react";

export type Language = "zh-CN" | "en-US";

const LANGUAGE_STORAGE_KEY = "app-language";
const DEFAULT_LANGUAGE: Language = "en-US";

type Messages = Record<string, string>;

const enUSMessages: Messages = {
  "导出单词为图片": "Export words as images",
  "导出Excel": "Export Excel",
  "不认识": "Unknown",
  "模糊": "Vague",
  "单词": "Word",
  "词性": "Part of speech",
  "常见搭配": "Common collocation",
  "例句": "Example sentence",
  "单词含义": "Word meaning",
  "搭配含义": "Collocation meaning",
  "例句含义": "Example meaning",
  "生词列表": "New words list",
  "当前页没有可加入计划的单词": "No words on this page can be added to the plan",
  "已加入计划：新增{{created}}，更新{{updated}}（当前第{{page}}/{{totalPages}}页）":
    "Added to plan: created {{created}}, updated {{updated}} (current page {{page}}/{{totalPages}})",
  "加入复习计划失败，请稍后重试":
    "Failed to add to review plan, please try again later",
  "共有 {{count}} 个生词": "{{count}} new words in total",
  "复习日历": "Review calendar",
  "将当前页加入艾宾浩斯计划": "Add current page to Ebbinghaus plan",
  "当前没有可学习的单词": "No words available to study right now",
  "卡片背单词": "Flashcard study",
  "打开全部翻译": "Show all translations",
  "关闭全部翻译": "Hide all translations",
  "翻译": "Translation",
  "选择学习范围": "Choose study scope",
  "仅学习当前页": "Study current page only",
  "学习当前页及之后所有": "Study this page and all following pages",
  "取消": "Cancel",
  "该日期没有生词记录": "No new words for this date",
  "选择其他日期查看生词，或继续学习添加新的生词":
    "Choose another date to view words, or keep learning to add new words",
  "中文": "中文",
  "英文": "English",
  "意见反馈": "Feedback",
  "添加桌面": "Add to desktop",
  "登录": "Login",
  "注册": "Register",
  "如果你发现网站有BUG或者有任何更好的想法，欢迎留言哦~":
    "If you find a bug or have better ideas, feel free to leave a message.",
  "请输入你的宝贵建议": "Please enter your valuable suggestion",
  "发送": "Send",
  "晋ICP备2024042419号-1": "晋ICP备2024042419号-1",
  "登录成功": "Login successful",
  "请输入你的手机号和密码进行登录":
    "Please enter your phone number and password to log in",
  "手机号": "Phone number",
  "Phone": "Phone",
  "Password": "Password",
  "密码": "Password",
  "记住密码": "Remember password",
  "忘记密码？": "Forgot password?",
  "还没有账号？": "No account yet?",
  "登录查看": "Login to view",
  "注册成功": "Registration successful",
  "下单": "Order",
  "设置密码": "Set password",
  "确认密码": "Confirm password",
  "授权码": "Authorization code",
  "验证码": "Verification code",
  "如何获取授权码": "How to get the authorization code",
  "已经有账号了？": "Already have an account?",
  "这是你的验证码": "This is your verification code",
  "请在小红书或淘宝搜索": "Please search on Xiaohongshu or Taobao",
  "复制成功": "Copied successfully",
  "复制": "Copy",
  "请输入你的账号和密码进行登录":
    "Please enter your account and password to log in",
  "邮箱": "Email",
  "Email": "Email",
  "请通过邮箱注册": "Please register with email",
  "Code": "Code",
  "获取验证码": "Get verification code",
  "Confrim Password": "Confirm Password",
  "忘记密码": "Forgot password",
  "如需修改密码，请联系客服协助处理":
    "If you need to change your password, please contact customer service.",
  "客服联系方式：": "Customer service contact:",
  "联系下单平台客服提供账号修改密码":
    "Contact the ordering platform customer service and provide your account to reset password",
  "我知道了": "Got it",
  "抱歉，您没有访问此页面的权限":
    "Sorry, you do not have permission to access this page",
  "抱歉，您没有访问此页面的权限。":
    "Sorry, you do not have permission to access this page.",
  "返回首页": "Back to home",
  "全部": "All",
  "未标注": "Unmarked",
  "认识": "Known",
  "还剩{{count}}个单词待翻译": "{{count}} words remaining to translate",
  "请选择主题": "Please select a topic",
  "复制单词中文名": "Copy Chinese meanings",
  "免责声明：该词库为网站用户所创建并公开分享，单词内容可能会有错误，请自行判断。":
    "Disclaimer: This vocabulary set is created and shared by users. Word content may contain errors, please judge by yourself.",
  "下载": "Download",
  "使用引导": "Guide",
  "默认": "Default",
  "乱一": "Shuffle 1",
  "乱二": "Shuffle 2",
  "学习模式": "Study mode",
  "列表模式": "List mode",
  "继续学习": "Continue learning",
  "第{{page}}页": "Page {{page}}",
  "暂无到期复习任务": "No due review tasks for now",
  "当前到期": "Due now",
  "今日已练": "Reviewed today",
  "今日计划": "Today's plan",
  "逾期任务": "Overdue tasks",
  "今日完成度：": "Today's completion:",
  "开始复习": "Start review",
  "生词本": "New words",
  "网站标记'不认识'的单词": "Words marked as 'unknown' on the site",
  "生词日历": "New words calendar",
  "按日期查看生词记录": "View new-word records by date",
  "查看艾宾浩斯计划与进度": "View Ebbinghaus plan and progress",
  "错词本": "Error words",
  "听写出错的单词": "Words with dictation mistakes",
  "我的笔记": "My notes",
  "查看我添加过笔记的单词": "View words I added notes to",
  "系统词库": "System vocabulary",
  "生词和错词": "New and error words",
  "词库广场": "Vocabulary plaza",
  "（用户公开的自定义词库和网站没有关系）":
    "(User-shared custom vocabularies are not affiliated with this site)",
  "查看更多...": "View more...",
  "我的词库": "My vocabulary",
  "提示": "Notice",
  "确定删除当前词库吗？": "Are you sure you want to delete this vocabulary?",
  "新建自定义词库": "Create custom vocabulary",
  "点击查看用户分享的词库": "Click to view user-shared vocabularies",
  "延世韩国语": "Yonsei Korean",
  "JLPT日语词汇": "JLPT Japanese Vocabulary",
  "TOPIK韩语词汇": "TOPIK Korean Vocabulary",
  "雅思单词库": "IELTS Vocabulary",
  "托福单词库": "TOEFL Vocabulary",
  "首尔大学韩国语": "Seoul National University Korean",
  "竖版两列": "Vertical two columns",
  "横版三列": "Horizontal three columns",
  "一月": "January",
  "二月": "February",
  "三月": "March",
  "四月": "April",
  "五月": "May",
  "六月": "June",
  "七月": "July",
  "八月": "August",
  "九月": "September",
  "十月": "October",
  "十一月": "November",
  "十二月": "December",
  "日": "Sun",
  "一": "Mon",
  "二": "Tue",
  "三": "Wed",
  "四": "Thu",
  "五": "Fri",
  "六": "Sat",
  "待": "Due",
  "练": "Done",
  "今天": "Today",
  "选中": "Selected",
  "待N": "Due N",
  "当天到期词数": "Due words of the day",
  "练N": "Done N",
  "当天已复习词数": "Reviewed words of the day",
  "新学": "New",
  "词数": "Count",
  "到期": "Due",
  "已练": "Reviewed",
  "艾宾浩斯复习": "Ebbinghaus review",
  "复习列表生成失败，请稍后重试":
    "Failed to generate review list, please try again later",
  "获取今日复习列表失败，请稍后重试":
    "Failed to fetch today's review list, please try again later",
  "获取今日计划明细失败，请稍后重试":
    "Failed to fetch today's plan details, please try again later",
  "已到期": "Overdue",
  "1小时内": "Within 1 hour",
  "今日稍后": "Later today",
  "当前没有已到期词可立即复习":
    "No overdue words available for immediate review",
  "返回上一页": "Go back",
  "艾宾浩斯复习日历": "Ebbinghaus Review Calendar",
  "开始今天复习": "Start today's review",
  "去安排复习": "Go schedule review",
  "待复习总数（含逾期）": "Total pending reviews (including overdue)",
  "本次可开始复习": "Available to start this round",
  "加载失败，请刷新重试": "Load failed, please refresh and retry",
  "本次返回 {{returnedCount}} 条，单次最多 {{listLimit}} 条":
    "Returned {{returnedCount}} items, max {{listLimit}} per request",
  "本月计划 / 已完成": "This month planned / completed",
  "逾期未复习": "Overdue not reviewed",
  "今天到期": "Due today",
  "点击查看今天到期时间分布":
    "Click to view today's due-time distribution",
  "说明：待复习总数包含历史积压；本次可开始复习是当前拉取到的词；今天到期表示今天时间窗口内到期的任务。":
    "Note: total pending includes backlog; available this round means currently fetched words; due today means tasks due within today's time window.",
  "当前复习列表已按上限截断，请分批完成。":
    "Current review list is capped, please complete in batches.",
  "有 {{count}} 条计划词缺少词条数据，已自动跳过。":
    "{{count}} planned words are missing vocabulary data and were skipped automatically.",
  "部分指标加载失败，当前展示可能不完整，请稍后重试。":
    "Some metrics failed to load, current view may be incomplete. Please try again later.",
  "复习概览": "Review overview",
  "计划到期": "Planned due",
  "完成率（已复习/到期）": "Completion rate (reviewed/due)",
  "阶段分布（R0~R7）": "Stage distribution (R0~R7)",
  "近7天趋势（到期 vs 已练）": "Last 7 days trend (due vs reviewed)",
  "怎么使用这页": "How to use this page",
  "按下面 5 步操作，可以快速开始并持续跟进复习。":
    "Follow the 5 steps below to start quickly and keep tracking your reviews.",
  "加入计划": "Add to plan",
  "：在「生词日历」中，将需要巩固的词「加入艾宾浩斯计划」，系统会按间隔排期。":
    ": In New Words Calendar, add words needing reinforcement to the Ebbinghaus plan. The system schedules them by intervals.",
  "看日历": "Check calendar",
  "：日历可切换月份；格子里的「待N」为当日计划到期词数，「练N」为当日有复习记录词数（点选某一天，左侧可看该日概览）。":
    ": Switch months in the calendar; 'Due N' shows planned due count, 'Done N' shows reviewed count for that day (click a day to view overview on the left).",
  "：点击「开始今日复习」进入听写列表，答对/答错会更新复习进度与下一阶段复习时间。":
    ": Click 'Start today's review' to enter dictation list. Correct/wrong answers update review progress and next review time.",
  "看数据": "Check data",
  "：通过左侧指标、阶段分布和近 7 天趋势，查看积压情况和最近完成量；如果「逾期未复习」偏高，建议先清掉今天到期任务。":
    ": Use left metrics, stage distribution and 7-day trend to track backlog and recent completion; if overdue is high, clear today's due tasks first.",
  "补排期": "Add scheduling",
  "：需要给更多词设复习计划时，点击「去排期」到生词日历，按日期管理并加入计划。":
    ": To schedule more words, click 'Go schedule review' to New Words Calendar, then manage by date and add to plan.",
  "今天到期任务分布（共 {{count}} 条）":
    "Today's due task distribution ({{count}} total)",
  "立即复习已到期任务": "Review overdue tasks now",
  "今天到期总数：{{total}}，当前展示：{{shown}}":
    "Total due today: {{total}}, currently shown: {{shown}}",
  "列表按上限 {{limit}} 条展示。":
    "List is displayed with limit {{limit}}.",
  "{{count}} 条计划词缺少词条数据，未显示。":
    "{{count}} planned words are missing vocabulary data and are not shown.",
  "今日到期分布": "Today's due distribution",
  "正在加载今天到期任务...": "Loading today's due tasks...",
  "今天没有到期任务。": "No tasks are due today.",
  "听写已终止": "Dictation terminated",
  "你已完成此次听写": "You have completed this dictation",
  "正确率": "Accuracy",
  "再来一次": "Try again",
  "退出": "Exit",
  "加载单词失败": "Failed to load words",
  "请输入单词": "Please enter a word",
  "当前暂无可练习的单词": "No words available to practice right now",
  "确定": "Confirm",
  "建议使用自带的回车键提交单词，使用更流畅":
    "Use the built-in Enter key to submit for a smoother experience",
  "上一个单词": "Previous word",
  "播放/暂停": "Play/Pause",
  "再读一遍": "Read again",
  "手写笔手写：IPad: 键盘语言切换为当前语种即可手写~":
    "Stylus handwriting: On iPad, switch keyboard language to current language to handwrite.",
  "其他品牌点击查看教程": "Other brands: click for tutorial",
  "终止听写": "Stop dictation",
  "音频": "Audio",
  "答对是否自动删除错词": "Auto remove wrong-word record on correct answer",
  "复习进度同步失败，稍后将自动重试":
    "Failed to sync review progress, will retry automatically later",
  "状态预热中": "Warming up",
  "状态启动": "Started",
  "节奏渐起": "Getting rhythm",
  "手感火热": "On fire",
  "渐入佳境": "In the zone",
  "锋芒尽显": "Peak sharpness",
  "势不可挡": "Unstoppable",
  "巅峰状态": "Peak state",
  "全场高光": "Spotlight moment",
  "{{count}}连胜": "{{count}} win streak",
  "缺少练习列表参数": "Missing practice list parameters",
  "练习列表已失效": "Practice list expired",
  "暂无列表练习数据": "No list practice data",
  "当前链接没有携带 listKey，请从列表入口重新进入。":
    "Current link does not contain listKey, please re-enter from list entry.",
  "复习列表已过期，请回到艾宾浩斯复习日历重新生成列表。":
    "Review list expired, please regenerate from Ebbinghaus review calendar.",
  "列表缓存已过期，请从原页面重新进入列表模式。":
    "List cache expired, please re-enter list mode from original page.",
  "当前复习列表为空，请回到艾宾浩斯复习日历重新发起。":
    "Current review list is empty, please restart from Ebbinghaus review calendar.",
  "请先在普通听写页面点击左上角“列表模式”进入。":
    "Please enter from top-left 'List mode' in regular dictation page first.",
  "返回复习日历": "Back to review calendar",
  "去普通听写": "Go to normal dictation",
  "已输入 {{answered}}/{{total}}": "Entered {{answered}}/{{total}}",
  "复习批次 {{count}} 条 / 当前已到期 {{due}}":
    "Review batch {{count}} items / currently due {{due}}",
  "复习批次 {{count}} 条": "Review batch {{count}} items",
  "正确 {{correct}}/{{answered}} ({{rate}}%)":
    "Correct {{correct}}/{{answered}} ({{rate}}%)",
  "艾宾浩斯复习入口（单批最多 {{limit}} 条）":
    "Ebbinghaus review entry (max {{limit}} per batch)",
  "结束听写": "End dictation",
  "正在加载更多单词...": "Loading more words...",
  "练习设置": "Practice settings",
  "音频自动播放": "Auto play audio",
  "隐藏中文释义": "Hide Chinese meaning",
  "使用技巧": "Tips",
  "· Tab / Enter：下一个输入框；Shift + Tab / Shift + Enter：上一个。":
    "· Tab / Enter: next input; Shift + Tab / Shift + Enter: previous.",
  "· 失焦、按 Tab 或 Enter 会自动校验并播放反馈音效。":
    "· Blur, Tab or Enter will auto validate and play feedback sound.",
  "· 开启“音频自动播放”后，聚焦输入框会自动朗读当前单词。":
    "· When auto play audio is on, focusing input auto reads current word.",
  "· 开启“答对自动删除错词”后，答对会自动从错词本移除。":
    "· When auto remove wrong-word is on, correct answers remove from wrong-word list.",
  "听写结果": "Dictation result",
  "本次最佳状态": "Best streak this round",
  "正确": "Correct",
  "可前往错词本查看并复习本次记录的错误单词。":
    "You can go to wrong-word list to review mistakes from this round.",
  "继续听写": "Continue dictation",
  "更多": "More",
  "不限": "Unlimited",
  "暂无场景": "No scenarios available",
  "词汇": "Vocabulary",
  "操作": "Actions",
  "用户笔记": "User notes",
  "公开我的笔记": "Make my notes public",
  "输入你的记忆笔记": "Enter your memory note",
  "没有更多了": "No more",
  "加载更多": "Load more",
  "听写": "Dictation",
  "选择听写范围": "Choose dictation scope",
  "仅听写当前页": "Dictate current page only",
  "听写当前页及之后所有": "Dictate this page and all following pages",
  "进度": "Progress",
  "点击一个单词或翻译，再点击对应的翻译或单词进行匹配":
    "Click a word or translation, then click its matching translation or word",
  "恭喜完成单词消消乐！": "Congrats! You completed Word Match!",
  "单词和翻译匹配游戏": "Word-translation matching game",
  "消消乐": "Word Match",
  "关联错词本": "Link to wrong-word list",
  "选中播放音频": "Play audio on selection",
  "场景": "Scenes",
  "主题": "Topics",
  "共 {{total}} 个单词": "{{total}} words in total",
  "每页显示条数": "Items per page",
  "条/页": " / page",
  "页码": "Page",
  "跳转": "Go",
  "请输入词库名称": "Please enter vocabulary name",
  "创建成功": "Created successfully",
  "创建失败，请重试": "Creation failed, please try again",
  "词库名称": "Vocabulary name",
  "创建中...": "Creating...",
  "创建": "Create",
  "通过选择分类来快速查找单词":
    "Quickly find words by selecting categories",
  "通过选择标签查看自己的单词学习情况吧":
    "Check your word-learning progress by selecting tags",
  "点击这里下载导出Excel文件哦~":
    "Click here to download and export the Excel file",
  "这里可以切换学习模式和表格模式哦":
    "Switch between study mode and list mode here",
  "点击这里对当前主题或分类的单词进行听写测试":
    "Start a dictation test for words in the current topic or category",
  "这里可以切换是否显示翻译":
    "Toggle whether translations are shown here",
  "点击小喇叭可以播放单词发音～":
    "Click the speaker icon to play word pronunciation",
  "点击小眼睛可以显示单词的翻译～":
    "Click the eye icon to show the word translation",
  "AI小助手可以提供翻译，语法纠错，单词拼写检查等功能等场景":
    "AI assistant can help with translation, grammar correction, spelling checks, and more",
  "下一步": "Next",
  "跳过": "Skip",
  "关闭": "Close",
  "上一步": "Back",
  "完成": "Done",
  "对选中的": "Dictate ",
  "个单词进行": " selected words",
  "确认删除吗？": "Confirm deletion?",
  "删除": "Delete",
  "临摹": "Trace",
  "设置": "Settings",
  "乱序": "Shuffle",
  "全选": "Select all",
  "请选择日期": "Please select dates",
  "已选择全部": "All selected",
  "已选择 {{n}} 个日期": "{{n}} dates selected",
  "选择日期": "Select dates",
  "最近一次听写": "Latest dictation",
  "{{count}}词": "{{count}} words",
  "错词已清空，快去学习吧": "Mistake list cleared — keep on learning!",
};

const dictionaries: Record<Language, Messages> = {
  "zh-CN": {},
  "en-US": enUSMessages,
};

const listeners = new Set<() => void>();

const getInitialLanguage = (): Language => {
  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY) as Language | null;
  if (saved === "zh-CN" || saved === "en-US") {
    return saved;
  }
  return DEFAULT_LANGUAGE;
};

let currentLanguage: Language = getInitialLanguage();

const notifyLanguageChange = () => {
  listeners.forEach((listener) => listener());
};

export const getLanguage = (): Language => currentLanguage;

export const setLanguage = (language: Language) => {
  if (currentLanguage === language) return;
  currentLanguage = language;
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  notifyLanguageChange();
};

const languageSubscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const interpolate = (text: string, params?: Record<string, string | number>) => {
  if (!params) return text;
  return Object.entries(params).reduce((content, [key, value]) => {
    return content.replace(new RegExp(`{{\\s*${key}\\s*}}`, "g"), String(value));
  }, text);
};

export const translate = (
  key: string,
  params?: Record<string, string | number>,
) => {
  if (currentLanguage === "zh-CN") {
    return interpolate(key, params);
  }
  const target = dictionaries[currentLanguage][key] ?? key;
  return interpolate(target, params);
};

export const $t = (key: string, params?: Record<string, string | number>) => {
  return translate(key, params);
};

export const useI18n = () => {
  const language = useSyncExternalStore(
    languageSubscribe,
    getLanguage,
    () => DEFAULT_LANGUAGE,
  );

  return {
    language,
    setLanguage,
    $t,
  };
};
